// 银行主数据API
export default {
  // 银行列表
  GET_LIST_BANK: '/maindata/sysBankBranch/listSysBankByPage',
  // 启用/禁用
  UPDATE_SYSBANK: '/maindata/sysBankBranch/updateSysBank',
  // 导入银行数据
  IMPORT_SYSBANK: '/maindata/sysBankBranch/importSysBank',
  // 字典表
  DICT_LIST: '/maindata/dictData/listDataDictByDataType',
};
